import React, { memo } from 'react'
import './SwitchButton.scss'

const SwitchButton = (props) => {
  const { className = '', onClick, disabled, checked, onChange } = props
  return <input type='checkbox' disabled={disabled} checked={checked} onClick={onClick} onChange={onChange} className={className} />
}

export default memo(SwitchButton)
